// Share one request among callers that ask for the same idempotent resource within
// a short window. Wallet bootstrap runs from several independent boot paths
// (StateProvider's deferred wallet task, useWalletDetails, each SHUAllet instance's
// debounces), so the same GET otherwise goes out two or three times within ~250ms.
// A failed request is dropped right away so the next caller retries.

type Entry = { at: number; promise: Promise<unknown>; pending: boolean }

export function createRecentRequestSharer(now: () => number = () => Date.now()) {
    const recent = new Map<string, Entry>()

    return function shareRecentRequest<T>(
        key: string,
        windowMs: number,
        run: () => Promise<T>,
    ): Promise<T> {
        const hit = recent.get(key)
        if (hit && (hit.pending || now() - hit.at < windowMs)) return hit.promise as Promise<T>

        const promise = run()
        const entry = { at: now(), promise, pending: true }
        recent.set(key, entry)
        void promise.then(
            () => {
                entry.pending = false
            },
            () => {
                if (recent.get(key) === entry) recent.delete(key)
            },
        )
        return promise
    }
}

export const shareRecentRequest = createRecentRequestSharer()
